<template>
  <div class="user-report-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- TODO举报类型要修改成接口获取-->
      <el-select placeholder="举报类型" v-model="params.objType" @change="getUserReport('status')" clearable size="small">
        <el-option v-for="item in objTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-select placeholder="举报分类" v-model="params.types" clearable size="small" @change="getUserReport('status')">
        <el-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-input placeholder="举报者用户ID" size="small" v-model="params.uid" class="param-input" clearable @keyup.enter.down="getUserReport('status')"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getUserReport('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="prohibits" :disabled="!multipleSelection.length">批量封禁</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column type="selection" align="center" width="50" fixed></el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="220" fixed>

        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="objID" label="举报视频ID" align="center" min-width="220">

        <template slot-scope="scope">
          <span>{{scope.row.objID || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="举报者ID" align="center" min-width="150">

        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="objType" label="举报类型" align="center" min-width="140">
        <template slot-scope="scope">
          {{scope.row.objType | objTypeRule}}
          <span v-if="scope.row.objType === 'comment'" class="view-comment" @click="checkedComment(scope.row.comment.content)">查看</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.cover" label="视频封面" align="center" min-width="110">
        <template slot-scope="scope">
          <img-load :src="imgUrl + scope.row.video.cover" :width="'70px'" :height="'80px'" />
        </template>
      </el-table-column>
      <el-table-column prop="video.sourceUrl" label="视频" align="center" min-width="110">
        <template slot-scope="scope">
          <i v-if="scope.row.video.sourceURL" class="el-icon-video-play views" title="点击预览" @click="checkMedia(scope.row.video.sourceURL,'video')"></i>
        </template>
      </el-table-column>
      <el-table-column prop="video.publisherID" label="视频发布者ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.video.publisherID || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="video.tags" label="标签" align="center" min-width="140">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags" v-for="(tag,i) in scope.row.video.tags" :key="i">{{'#' + tag.name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reptStatus" label="处理状态" align="center" min-width="180">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.reptStatus" @change="setRept(scope.row)" size="small"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="types" label="举报分类" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.types || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="举报时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="110">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.video.hasLocked" type="danger" size="mini" @click="prohibit(scope.row)">封禁</el-button>
          <el-button v-else type="info" size="mini" @click="unprohibit(scope.row)">解封</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 5, 10, 15, 20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 5" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--查看评论弹窗-->
    <comment-popup ref="commentPopup"></comment-popup>
  </div>
</template>
<script>
import mediaPopup from '@/components/media-popup'
import commentPopup from './components/comment-popup'
import {changeTime} from '@/utils/global'
import baseConfig from '@/utils/serverUrlConfig'
import API from '@/api'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      time: '',
      imgUrl: baseConfig.imgUrl,
      multipleSelection: [],
      params: {
        pageNumber: 1,
        pageSize: 5,
        key: '',
        value: '',
        uid: '',
        types: '',
        objType: '',
        startTime: '',
        endTime: ''
      },
      objTypeList: [
        { label: '影视', value: 'video' },
        { label: '用户', value: 'user' },
        { label: '评论', value: 'comment' },
      ],
      typeList: [
        { label: '广告', value: '广告' },
      ],
    }
  },
  filters: {
    objTypeRule(value) {
      let obj = { video: '影视', user: '用户', comment: '评论' }
      return obj[value] ? obj[value] : '未知'
    }
  },
  components: {
    mediaPopup,
    commentPopup
  },
  created() {
    this.getReportTypes()
    this.getUserReport()
  },
  methods: {
    // 修改处理状态
    setRept(row) {
      let params = {
        status: row.reptStatus,
        reptID: row.id
      }
      API.setRept(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '修改处理状态成功',
            type: 'success'
          })
        }
      })
    },
    // 请求举报分类列表
    getReportTypes() {
      API.getReportTypes().then(res => {
        if (res.code === 200 && res.data) {
          this.typeList = res.data.map(item => {
            return {
              label: item,
              value: item
            }
          })
        } else {
          this.typeList = []
        }
      }).catch(() => {
      })
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0])
        this.params.endTime = changeTime(time[1])
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getUserReport('status')
    },
    // 请求用户举报列表
    getUserReport(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getUserReport(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getUserReport()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getUserReport()
    },
    // 批量封禁用户
    prohibits() {
      this.$confirm('您确定要封禁当前选择的被举报用户吗？', '封禁提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            uidList: this.multipleSelection.map(item => item.video.publisherID),
            enable: true
          }
          this.lockUser(params)
        })
        // eslint-disable-next-line no-unused-vars
        .catch(_ => { });
    },
    // 封禁用户
    prohibit(row) {
      this.$confirm('您确定要封禁当前被举报用户吗？', '封禁提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            uidList: [row.video.publisherID],
            enable: true
          }
          this.lockUser(params)
        })
        // eslint-disable-next-line no-unused-vars
        .catch(_ => { });
    },
    // 解禁用户
    unprohibit(row) {
      this.$confirm('您确定要解封当前被举报用户吗？', '解封提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            uidList: [row.video.publisherID],
            enable: false
          }
          this.lockUser(params)
        })
        .catch(() => { });
    },
    lockUser(params) {
      API.getUserLock(params).then(res => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: '封禁用户成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '解封用户成功',
              type: 'success'
            })
          }
          this.getUserReport()
        } else {
          if (params.enable) {
            this.$message.error('封禁用户失败')
          } else {
            this.$message.error('解封用户失败')
          }
        }
      })
        .catch(() => { });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type)
    },
    // 查看评论
    checkedComment(content) {
      this.$refs.commentPopup.open(content)
    }
  }
}
</script>
<style scoped lang="scss">
.user-report-box {
  .view-comment {
    color: #e63765;
    cursor: pointer;
    margin-left: 5px;
    &:hover {
      color: #e63765;
      text-decoration: underline;
    }
  }
}
</style>
